import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { acceptInvitation } from "@/redux/actions/usersActions";

const AcceptInvitation = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: any = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Get the token from the query parameter
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const handleSubmit = () => {
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }
    setErrorMessage("");
    dispatch(acceptInvitation(token, password, () => navigate("/login")));
  };

  return (
    <div className="w-full max-w-md mx-auto mt-8 p-6 border border-gray-200 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold text-center mb-4">
        Create Password
      </h2>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Enter Password
        </label>
        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full"
        />
      </div>
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Confirm Password
        </label>
        <Input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full"
        />
      </div>
      {errorMessage && (
        <p className="text-red-500 text-sm mb-4">{errorMessage}</p>
      )}
      <Button
        disabled={password !== confirmPassword || password.length < 8}
        onClick={handleSubmit}
        className="w-full"
      >
        Submit
      </Button>
    </div>
  );
};

export default AcceptInvitation;
